export default "__VITE_ASSET__bsadBIt___"